/** InsCoder WANG.J 2026-08-17 B + Shopable Quiz theme editor lifecycle **/

(function () {
  var selector = '[data-cust-shopable-quiz]';

  function initialize(root) {
    if (!root || root.dataset.custShopableQuizReady === 'true') {
      return;
    }

    root.dataset.custShopableQuizReady = 'true';
  }

  function initializeAll() {
    document.querySelectorAll(selector).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target.querySelector(selector));
  });
})();

/** InsCoder WANG.J 2026-08-17 E + Shopable Quiz theme editor lifecycle **/
